﻿import React from "react";

interface NavLinkProps {
    LinkText: string;
    LinkUrl: string;
    NewWindow: boolean;
    IconUrl: string;
    Bold: boolean;
}

const NavLink = (props:NavLinkProps) => {

    return (
        <a 
            href={props.LinkUrl} 
            target={props.NewWindow ? '_blank' : '_self'}
            className={props.Bold ? "bold" : ""}
        >
            {props.LinkText}
        </a>
    )
}

export default NavLink